// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3N2W8","log":"ModalInventoryLogs_log__3cmTL","date":"ModalInventoryLogs_date__7Cs6L","userName":"ModalInventoryLogs_userName__25CVx"};